module.exports = __webpack_public_path__ + "static/media/aiota-logo.035c8dda.jpeg";